import {
    ReactElement,
    cloneElement,
    Children,
} from 'react';

import { IParentProps } from '../../shared/types/IParentProps';
import { IStyleableProps } from '../../shared/types/IStyleableProps';

import { BUTTON_SIZE } from './BUTTON_SIZE';
import { BUTTON_STYLE } from './BUTTON_STYLE';

const sizes: Record<BUTTON_SIZE, string> = {
    [BUTTON_SIZE.LARGE]: 'h-7 text-lg',
    [BUTTON_SIZE.MEDIUM]: 'h-6 text-med',
    [BUTTON_SIZE.SMALL]: 'h-4',
};

const px: Record<BUTTON_SIZE, string> = {
    [BUTTON_SIZE.LARGE]: 'px-4',
    [BUTTON_SIZE.MEDIUM]: 'px-3',
    [BUTTON_SIZE.SMALL]: 'px-2',
};

type ISizeButtonProps = IParentProps<ReactElement> & IStyleableProps & {
    style: BUTTON_STYLE;
    size: BUTTON_SIZE;
};

export function SizedButton (props: ISizeButtonProps): ReactElement {
    const {
        size = BUTTON_SIZE.MEDIUM,
        style = BUTTON_STYLE.PRIMARY,
        children,
        className,
    }: ISizeButtonProps = props;

    const isLink: boolean = !style || [BUTTON_STYLE.LINK, BUTTON_STYLE.LINK_LIGHT].includes(style);
    // ensures only a single child
    const child: ReactElement = Children.only(children);

    return cloneElement(child, {
        className: `${sizes[size]} ${(!isLink) ? px[size] : ''} ${className} ${child.props.className}`,
    });
}
